<div
    data-cy="channel-group-search-bar"
    class="labelled-block-textbox search-input-textbox"
    (click)="focusWrapTarget()"
    [ngClass]="{ selected: isFocused }"
>
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
    <ng-content></ng-content>
</div>
